import { render, staticRenderFns } from "./AssignmentView.vue?vue&type=template&id=5aaa1ce4&scoped=true&"
import script from "./AssignmentView.vue?vue&type=script&lang=js&"
export * from "./AssignmentView.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentView.vue?vue&type=style&index=0&id=5aaa1ce4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa1ce4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCol,VRow})
